import script from "./QuestionNode.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionNode.vue?vue&type=script&setup=true&lang=js"

import "./QuestionNode.vue?vue&type=style&index=0&id=6c42b9de&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c42b9de"]])

export default __exports__